<template>
  <section>
    <div class="row">
      <div v-for="item of componentItems" :key="item.id" :class="classWidth">
        <component-gauge :componentName="item.name" />
        <component-list :componentName="item.name" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import ComponentGauge from '@/Components/UserCardio/client/progress/component-gauge'
import ComponentList from '@/Components/UserCardio/client/progress/component-list'
export default {
  name: 'component-status',
  components: {
    ComponentGauge,
    ComponentList,
  },
  computed: {
    ...mapGetters('dashboardComponents', ['memberStatus']),
    componentItems() {
      let _data = []
      if (this.memberStatus) {
        let last = null
        let cnt = 0
        this.memberStatus.forEach((element) => {
          if (last !== element.componentName) {
            _data.push({
              id: cnt,
              name: element.componentName,
            })
            cnt++
            last = element.componentName
          }
        })
      }
      return _data
    },
    classWidth() {
      let _width = 'col-md-12'
      if (this.componentItems) {
        switch (this.componentItems.length) {
          case 1:
            _width = 'col-md-12'
            break
          case 2:
            _width = 'col-md-6'
            break
          case 3:
            _width = 'col-md-4'
            break
          case 4:
            _width = 'col-md-3'
            break
        }
      }
      return _width
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.custom-chart {
  position: relative;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
  div {
    position: relative;
    bottom: 0px;
  }
  span {
    position: absolute;
    text-align: center;
    margin: 0 auto;
    font-size: 1.8em;
    left: 0;
    top: 44px;
    width: 100%;
  }
}
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  width: 100%;
}
.custom-listing {
  width: 100%;
}
.custom-viewed {
  cursor: default;
}
</style>
